import React, { useEffect, useState } from "react";
import { APP } from "../../constant/theme";

const pad = (n) => String(n).padStart(2, "0");

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const formatDate = (date) =>
  `${WEEKDAYS[date.getDay()]}, ${pad(date.getDate())} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;

const formatTime = (date) => {
  let hours = date.getHours();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  return `${pad(hours)}:${pad(date.getMinutes())}:${pad(date.getSeconds())} ${ampm}`;
};

const NavbarClock = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!APP.navbarClock?.show) {
    return null;
  }

  return (
    <div className="header-datetime-pill">
      <div className="datetime-item">
        <div className="datetime-icon-badge">
          <i className="bx bx-calendar"></i>
        </div>
        <span className="datetime-text">{formatDate(now)}</span>
      </div>

      <div className="datetime-divider"></div>

      <div className="datetime-item">
        <div className="datetime-icon-badge">
          <i className="bx bx-time-five"></i>
        </div>
        <span className="datetime-text">{formatTime(now)}</span>
      </div>
    </div>
  );
};

export default NavbarClock;
